import * as React from "react";
import { useState } from "react";
import { UitkTextInput } from "@egencia/uitk-react";

const searchBoxPlaceholder = uitk.i18n.msg('search_box_placeholder');

export const FaqSearch = ({onSearch}) => {
    const [value, setValue] = useState("");
    
    function handleChange(e) {
        onSearch && onSearch(e.target.value);
        setValue(e.target.value);
    }
    
    return (
        <UitkTextInput
            id="faq-search" 
            name="faq-search" 
            label={searchBoxPlaceholder} 
            icon="search" 
            onChange={handleChange} 
            value={value}
            maxLength={255}
        />
    );
};